import React from "react";
import StorySectionStyle from "../../components/Sections/StorySectionStyle";
import { Box } from "@mui/material";

const Description = () => {
  return (
    <Box
      sx={{
        fontSize: { xs: "16px", lg: "18px" },
        lineHeight: 1.4,
        opacity: 0.9,
      }}
    >
      <p
        style={{
          marginTop: 0,
        }}
      >
        We are a Boutique Strategy & Project Management Firm, driven by the
        belief that smart investments begin with strategic insight and the
        limitless potential of people.
      </p>
      <p>
        As experienced Business Craftsmen, we operate at the intersection of
        growth and transformation, redefining what it means to invest with
        purpose. We partner with SMEs, Family Businesses and Investors, seeking
        beyond traditional equity and scaling strategies. Through tailored
        restructuring and business model innovation, we craft sustainable
        solutions that prioritize long-term value over short-term gains.
      </p>
    </Box>
  );
};

const storySection = {
  title: "Our Story",
  content: <Description />,
  description: "",
};
export default function StorySection({ id }) {
  return <StorySectionStyle section={storySection} id={id} />;
}
